import { render, staticRenderFns } from "./DocumentationRequirements.vue?vue&type=template&id=359e2ae4"
import script from "./DocumentationRequirements.vue?vue&type=script&lang=ts"
export * from "./DocumentationRequirements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359e2ae4')) {
      api.createRecord('359e2ae4', component.options)
    } else {
      api.reload('359e2ae4', component.options)
    }
    module.hot.accept("./DocumentationRequirements.vue?vue&type=template&id=359e2ae4", function () {
      api.rerender('359e2ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/DocumentationRequirements.vue"
export default component.exports